import { useEffect, useState } from "react";

export function ImageLightbox({ src, alt, className }: { src: string; alt: string; className?: string }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const close = (event: KeyboardEvent) => { if (event.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [open]);
  return <>
    <button className="image-lightbox-trigger" type="button" onClick={() => setOpen(true)} aria-label={`Enlarge ${alt}`}><img className={className} src={src} alt={alt} /></button>
    {open && <div className="image-lightbox" role="dialog" aria-modal="true" aria-label={`${alt} image`} onClick={() => setOpen(false)}>
      <button type="button" aria-label="Close image" onClick={() => setOpen(false)}>×</button>
      <img src={src} alt={alt} onClick={(event) => event.stopPropagation()} />
    </div>}
  </>;
}
